<div class="modal-header">
  <h3>Notification</h3>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-3"><label class="control-label">Subject</label></div>
        <div class="col-md-9"><input type="text" class="form-control" [(ngModel)]="notificationSubject"/></div>
      </div>
      <label class="control-label">Body</label>
      <app-editor [(text)]="notificationContent"></app-editor>

    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-warning" (click)="activeModal.dismiss()">Cancel</button>
  <button class="btn btn-primary" (click)="submit()">Submit</button>
<!--  <button class="btn btn-primary" ng-show="sending"><i class="fa fa-spinner fa-pulse"></i></button>-->
</div>
